import template from './dashboard.html';
import controller from './dashboard.controller';

let dashboardComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default dashboardComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/dashboard/dashboard.component.js